import {
  ISalesInfo,
  ISalesPipelineInfo,
  ITargetVsActualSales,
  ISalesCards,
  ISalesByUtility,
  ISalesLeaderboard,
} from "sales/models";
import { http } from "shared/api/http";

const buildSalesPath = (tenantId: string, organizationId: string) =>
  `${process.env.REACT_APP_API_BASE_URL}/api/v1/tenants/${tenantId}/organizations/${organizationId}/sales`;

/**
 * Consolidated dashboard call — fetches all sales data in a single request.
 */
export const getSalesInfo = async (tenantId: string, organizationId: string) => {
  const res = await http.get<ISalesInfo>(
    `${buildSalesPath(tenantId, organizationId)}/info`
  );
  return res?.data;
};

export const getTargetVsActualSales = async (tenantId: string, organizationId: string) => {
  const res = await http.get<ITargetVsActualSales[]>(
    `${buildSalesPath(tenantId, organizationId)}/target-vs-actual`
  );
  return res?.data;
};

export const getSalesSummaryCards = async (tenantId: string, organizationId: string) => {
  const res = await http.get<ISalesCards>(
    `${buildSalesPath(tenantId, organizationId)}/summary-cards`
  );
  return res?.data;
};

export const getSalesByUtility = async (tenantId: string, organizationId: string) => {
  const res = await http.get<ISalesByUtility[]>(
    `${buildSalesPath(tenantId, organizationId)}/by-utility`
  );
  return res?.data;
};

export const getSalesLeaderboard = async (tenantId: string, organizationId: string) => {
  const res = await http.get<ISalesLeaderboard[]>(
    `${buildSalesPath(tenantId, organizationId)}/leaderboard`
  );
  return res?.data;
};

export const getSalesPipelineInfo = async (tenantId: string, organizationId: string) => {
  const res = await http.get<ISalesPipelineInfo>(
    `${buildSalesPath(tenantId, organizationId)}/pipeline/info`
  );
  return res?.data;
};
